import { FSAInterface } from '../actions';

const _CLEAR = '_CLEAR';

export default (store: any) => (next: Function) => (action: FSAInterface<any>) => {
  const { type } = action;

  const matches = /(.*)_(SUCCESS|FAILURE)/.exec(type);

  if (!matches) return next(action);
  const [, requestName] = matches;

  setTimeout(() => {
    return next({
      type: `${requestName}${_CLEAR}`,
    });
  }, 2000);

  return next(action);
};
